// extracted by mini-css-extract-plugin
export default {"deductionItem":"Deductions_deductionItem__JCze8","discountName":"Deductions_discountName__kUFuA","discountValue":"Deductions_discountValue__429Vy"};